<template>
  <footer>
    <div class="wrapper">
      <div class="inner">
        <div class="main">
          <div class="foot-list">
            <div class="logo">
              <a href="index.html"
                ><img
                  src="@/images/logo-wh.png"
                  alt="Reeracoen Freelance Recruiting Business"
              /></a>
            </div>
            <div class="link-group">
              <div>
                <a class="link" href="#" target="_blank">Reeracoen Thailand</a>
              </div>
              <div class="phone">
                <a class="link icon-link" href="tel:+6602-253-9800"
                  ><i class="fas fa-phone-volume"></i>(+66) 02-253-9800</a
                >
              </div>
              <div class="socials">
                <span>Follow Us</span>
                <div class="socials-group">
                  <ul class="list">
                    <li class="facebook">
                      <a href="/"><i class="fab fa-facebook-f"></i></a>
                    </li>
                    <li class="linkedin">
                      <a href="/"><i class="fab fa-linkedin-in"></i></a>
                    </li>
                    <li class="line">
                      <a href="/"><i class="fab fa-line"></i></a>
                    </li>
                    <li class="youtube">
                      <a href="/"><i class="fab fa-youtube"></i></a>
                    </li>
                    <li class="mail">
                      <a href="/"><i class="fas fa-envelope"></i></a>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
            <div class="copyright">
              <p>Copyright © 2021 Reeracoen. All rights reserved.</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </footer>
</template>
<script>
export default {
  name: "Footer",
};
</script>
<style scoped lang="scss">
@import "@/assets/stylesheets/application";
footer {
  background: linear-gradient(180deg, #3742fa 0%, #000ce2 100%);
  padding: 2rem 0;
  width: 100%;

  .foot-list {
    align-items: center;
    display: flex;
    flex-direction: column;

    & > * {
      margin-bottom: 3rem;
    }

    .logo {
      img {
        opacity: 0.8;
        width: 200px;
      }
    }

    .link-group {
      align-items: center;
      display: flex;
      flex-direction: row;
      flex-wrap: wrap;
      justify-content: space-between;
      width: 100%;

      & > * {
        margin-bottom: 0;
      }

      .link {
        color: $white;
        font-size: 1em;
        font-weight: 500;
        opacity: 0.8;

        &:hover,
        &:focus {
          opacity: 1;
        }
      }

      .icon-link {
        align-items: center;
        display: flex;
        flex-direction: row;
        flex-wrap: wrap;
        justify-content: space-between;
      }

      .phone {
        i {
          font-size: 20px;
          margin-right: 8px;
          transform: rotate(-45deg);
        }
      }

      .socials {
        align-items: center;
        display: flex;
        flex-direction: row;
        flex-wrap: wrap;

        span {
          color: $white;
          font-size: 1em;
          font-weight: 500;
          margin-right: 10px;
          opacity: 0.8;
        }

        .socials-group {
          .list {
            display: flex;
            flex-direction: row;
            flex-wrap: wrap;

            li {
              margin-bottom: 0;
            }

            a {
              color: $white;
              font-size: 1em;
              margin-right: 12px;
              opacity: 0.8;

              &:hover,
              &:focus {
                opacity: 1;
              }
            }
          }
        }
      }
    }

    .copyright {
      color: $white;
      font-size: 0.85rem;
      letter-spacing: 1px;
      margin-bottom: 0;
      margin-top: 2rem;
      opacity: 0.65;
      text-align: center;
    }
  }
}
@media only screen and (max-width: 991px) {
  footer {
    .foot-list {
      & > * {
        margin-bottom: 1.5rem;
      }

      .logo {
        img {
          width: 150px;
        }
      }

      .link-group {
        align-items: center;
        display: flex;
        flex-direction: column;

        & > * {
          margin-bottom: 1rem;
        }
      }

      .copyright {
        font-size: 10px;
        margin-bottom: 0;
        margin-top: 0;
      }
    }
  }
}
</style>
